var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoiceDetails" },
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.changeCurrency,
              modalData: _vm.modalData,
              validate: "cityCurrency",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (slotProps) {
                    return _c(
                      "div",
                      {},
                      [
                        _c("currencySelect", {
                          attrs: {
                            drug: _vm.modalData.drug,
                            updateCurrency: slotProps.updateCurrency,
                            updateModalData: slotProps.updateModalData,
                          },
                        }),
                      ],
                      1
                    )
                  },
                },
              ],
              null,
              false,
              260866382
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { width: "50" } }, [_vm._v("№")]),
            _vm._v(" "),
            _vm.useCurrency
              ? _c("th", { staticClass: "wrap", attrs: { width: "50" } }, [
                  _vm._v("Другая валюта"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("th", { staticClass: "drug_field" }, [_vm._v("Препарат")]),
            _vm._v(" "),
            _c("th", [_vm._v("Количество")]),
            _vm._v(" "),
            _vm.invoiceType == "income"
              ? _c("th", [_vm._v("Стоимость")])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceType == "income"
              ? _c("th", [_vm._v("Сумма")])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceType == "income"
              ? _c("th", [_vm._v("Скидка")])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceType !== "income"
              ? _c("th", [_vm._v("Себестоимость")])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceType == "transit" || _vm.invoiceType == "writeOff"
              ? _c("th", [_vm._v("Наличие")])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.drugList, function (drug, index) {
            return _c("tr", { key: index }, [
              _c("td", [_vm._v(_vm._s(index + 1))]),
              _vm._v(" "),
              _vm.useCurrency
                ? _c("td", [
                    _c("div", { staticClass: "flex v-align-center" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: drug.anotherCurrency,
                            expression: "drug.anotherCurrency",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(drug.anotherCurrency)
                            ? _vm._i(drug.anotherCurrency, null) > -1
                            : drug.anotherCurrency,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = drug.anotherCurrency,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      drug,
                                      "anotherCurrency",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      drug,
                                      "anotherCurrency",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(drug, "anotherCurrency", $$c)
                              }
                            },
                            function ($event) {
                              return _vm.clearDrug(
                                drug.drug ? drug.drug.id : null
                              )
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      drug.drug &&
                      drug.anotherCurrency &&
                      drug.drug.income_currency_id !==
                        _vm.invoice.currency_alias
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-xs m-l-5 small_padding",
                              on: {
                                click: function ($event) {
                                  return _vm.changingCurrency(drug)
                                },
                              },
                            },
                            [_vm._v("сменить\n          ")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("DrugSearchNew", {
                    ref: `search_drug_${index}`,
                    refInFor: true,
                    attrs: {
                      selectedDrug: drug.drug,
                      onSelect: (d) => _vm.addDrug(index, d),
                      storeIdRequest: _vm.invoice.store_out,
                      searchOptions:
                        _vm.invoiceType === "writeOff"
                          ? null
                          : {
                              lastIncomeInvoice: true,
                              currencyId:
                                _vm.invoiceType === "income"
                                  ? !drug.anotherCurrency
                                    ? _vm.invoice.currency_id
                                    : false
                                  : false,
                            },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "drug_info_block" }, [
                    drug.drug && drug.drug.pack_set && +drug.drug.pack_set !== 1
                      ? _c("p", [
                          _vm._v("Препарат комплектный: "),
                          _c("span", { staticClass: "badge badge-info" }, [
                            _vm._v("1 комплект"),
                          ]),
                          _vm._v(" - "),
                          _c("strong", [_vm._v(_vm._s(drug.drug.pack_set))]),
                          _vm._v(" (зав.уп.)"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    drug.drug && drug.drug.cool
                      ? _c("p", [
                          _c("span", { staticClass: "icon icon-snowflake" }),
                          _vm._v(" необходим хладоген"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    drug.drug && drug.drug.pack_comment
                      ? _c("p", { staticClass: "pack_comment" }, [
                          _vm._v(_vm._s(drug.drug.pack_comment)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    drug.drug && drug.drug.pack_box_comment
                      ? _c("p", { staticClass: "pack_box_comment" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(drug.drug.pack_box_comment)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "vtop" }, [
                drug.drug
                  ? _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|decimal",
                            expression: "'required|decimal'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: drug.drug.qty,
                            expression: "drug.drug.qty",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          name: `req_qty_${drug.drug.id}`,
                          placeholder: "Кол. упаковок",
                          "data-vv-as": "Кол. упаковок",
                        },
                        domProps: { value: drug.drug.qty },
                        on: {
                          change: _vm.updateDiscountData,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(drug.drug, "qty", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.has(`req_qty_${drug.drug.id}`)
                        ? _c(
                            "small",
                            { staticClass: "form-text text-danger" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.errors.first(`req_qty_${drug.drug.id}`)
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      drug.drug.pack_set && drug.drug.pack_set != 1
                        ? _c("p", [_vm._v("зав.уп.")])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.invoiceType == "income"
                ? _c("td", { staticClass: "vtop" }, [
                    drug.drug
                      ? _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|decimal",
                                expression: "'required|decimal'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: drug.drug.price,
                                expression: "drug.drug.price",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "number",
                              name: `req_price_${drug.drug.id}`,
                              placeholder: "Стоимость",
                              "data-vv-as": "Стоимость",
                            },
                            domProps: { value: drug.drug.price },
                            on: {
                              change: _vm.updateDiscountData,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  drug.drug,
                                  "price",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has(`req_price_${drug.drug.id}`)
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.errors.first(
                                          `req_price_${drug.drug.id}`
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType == "income"
                ? _c("td", { staticClass: "vtop" }, [
                    drug.drug
                      ? _c("span", [_vm._v(_vm._s(_vm.printSumm(drug.drug)))])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType == "income"
                ? _c("td", { staticClass: "vtop" }, [
                    _c("div", {
                      staticClass: "discount_div",
                      domProps: {
                        innerHTML: _vm._s(_vm.printDiscount(drug.drug)),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType !== "income"
                ? _c(
                    "td",
                    { staticClass: "mid_right" },
                    [
                      drug && drug.drug && _vm.loadingCostPrice[drug.drug.id]
                        ? [
                            _c("clip-loader", {
                              attrs: {
                                loading: true,
                                color: _vm.$constants.LOADING_COLOR,
                                size: "20px",
                              },
                            }),
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  drug.drug && _vm.costPriceData[drug.drug.id]
                                ) +
                                "\n        "
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceType == "transit" || _vm.invoiceType == "writeOff"
                ? _c(
                    "td",
                    { staticClass: "mid_right" },
                    [
                      drug && drug.drug
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  (_vm.storeData &&
                                    _vm.storeData[drug.drug.id]) ||
                                    (drug.drug.in_store &&
                                      drug.drug.in_store.qty) ||
                                    "00"
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }